import flight from './flight'

export default [flight]
